// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"59b45365","134":"c6f2cacc","135":"711590bc","181":"e4fc1b81","213":"21fc5be7","455":"cc7920d4","616":"a3bc5b09","672":"186f0c65","695":"abe0826b","697":"266b4ecb","782":"a781bcfc","822":"13ce002e","908":"e6d4263a","942":"2def6aa0"}[chunkId] + ".chunk.js";
};